import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Yasmina Lembachar
 * id F8E5E9B6-9953-46F8-84DC-CFBB11DEFFB7
 * name dice-1
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/dice-1.svg
 * tags
 * - Gaming / RPG 
 */
export const Dice1Icon = createSvgIcon(<><path d="M5,3H19A2,2 0 0,1 21,5V19A2,2 0 0,1 19,21H5A2,2 0 0,1 3,19V5A2,2 0 0,1 5,3M12,10A2,2 0 0,0 10,12A2,2 0 0,0 12,14A2,2 0 0,0 14,12A2,2 0 0,0 12,10Z" /></>, 'Dice1Icon');
export default Dice1Icon